module.exports = __webpack_public_path__ + "static/why-jenga-three-f6eaa58344611ece3df9bfad273d52b5.svg";